import { Header, Paragraph } from "@datagame/ui";
import { useTranslation } from "react-i18next";

import { UploadForm } from "./UploadForm";

import styles from "./UploadSection.module.scss";

export const UploadSection = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.section}>
      <div className={styles.headerWrapper}>
        <Header variant="h5">{t("library:uploadSection.header")}</Header>
        <Paragraph color="secondary" size="small">
          {t("library:uploadSection:description")}
        </Paragraph>
      </div>

      <UploadForm />
    </div>
  );
};
